
import { useCallback, useSyncExternalStore } from 'react';
import { BREAKPOINT_QUERIES, type Breakpoint } from '@client/shared/design/breakpoints.ts';

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onStoreChange);
      return () => list.removeEventListener('change', onStoreChange);
    },
    [query],
  );
  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);
  return useSyncExternalStore(subscribe, getSnapshot);
}

export function useBreakpoint(): Breakpoint {
  const tabletUp = useMediaQuery(BREAKPOINT_QUERIES.tabletUp);
  const tabletWideUp = useMediaQuery(BREAKPOINT_QUERIES.tabletWideUp);
  const desktopUp = useMediaQuery(BREAKPOINT_QUERIES.desktopUp);
  return desktopUp ? 'desktop' : tabletWideUp ? 'tabletWide' : tabletUp ? 'tablet' : 'phone';
}
